import { z } from 'zod';
import { findProductsExtendedInputSchema } from './products';

export const productConsistencyCheckerRules = [
  'TZ_MATCH_LOCATION',
  'PRICING_CONSISTENCY',
] as const;
export const productConsistencyCheckerRuleSchema = z.enum(
  productConsistencyCheckerRules
);
export type ProductConsistencyCheckerRule = z.infer<
  typeof productConsistencyCheckerRuleSchema
>;

// Input: every filter the products list page accepts, plus the rules to run.
// Pagination is stripped (the checker reports per-product violations across
// the full filtered set).
export const productConsistencyCheckerInput =
  findProductsExtendedInputSchema.extend({
    rules: z.array(productConsistencyCheckerRuleSchema).min(1),
  });
export type ProductConsistencyCheckerInput = z.infer<
  typeof productConsistencyCheckerInput
>;

// Output: per-violation row. Mirrors legacy `ProductConsistencyCheckerResult`.
export const productConsistencyCheckerViolationSchema = z.object({
  rule: productConsistencyCheckerRuleSchema,
  id: z.uuid(),
  title: z.string(),
  message: z.string().optional(),
  expected: z.string().optional(),
  actual: z.string().optional(),
  meta: z.record(z.string(), z.unknown()).optional(),
});
export type ProductConsistencyCheckerViolation = z.infer<
  typeof productConsistencyCheckerViolationSchema
>;

export const productConsistencyCheckerResult = z.object({
  countAll: z.number().int().nonnegative(),
  data: z.array(productConsistencyCheckerViolationSchema),
});
export type ProductConsistencyCheckerResult = z.infer<
  typeof productConsistencyCheckerResult
>;
